import { render } from "./InternFeedback.vue?vue&type=template&id=03ab127d"
import script from "./InternFeedback.vue?vue&type=script&lang=js"
export * from "./InternFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__